export default "__VITE_ASSET__BBnnpb0b__"